import { AMERICACHANGETRIP, AMERICAADDADULT, AMERICAMINUSADULT, AMERICAADDCHILDREN, AMERICAMINUSCHILDREN, AMERICAPICKDATE, AMERICAADDTOCART, AMERICAREMOVEFROMCART, AMERICAAIRPORTPICKUP, AMERICADIFFERENTHOTEL, AMERICAMORETRIPS, AMERICAREMOVEALL } from "./AmericaTypes";

export function americaChangeTrip(id, e) {
  return { type: AMERICACHANGETRIP, payload: id, data: e.target.value };
}

export function americaAddAdult(id, e) {
  e.preventDefault()
  return { type: AMERICAADDADULT, payload: id };
}

export function americaMinusAdult(id, e) {
  e.preventDefault()
  return { type: AMERICAMINUSADULT, payload: id };
}

export function americaAddChildren(id, e) {
  e.preventDefault()
  return { type: AMERICAADDCHILDREN, payload: id };
}

export function americaMinusChildren(id, e) {
  e.preventDefault()
  return { type: AMERICAMINUSCHILDREN, payload: id };
}

export function americaPickDate(id, e) {
  return { type: AMERICAPICKDATE, payload: id, data: e.target.value };
}

export function americaAddToCart(id, e) {
  e.preventDefault()
  return { type: AMERICAADDTOCART, payload: id, data: e.target.value };
}

export function americaRemoveFromCart(id, e) {
  e.preventDefault()
  return { type: AMERICAREMOVEFROMCART, payload: id, data: e.target.value };
}

export function americaAirportPickUp(id, e) {
  return {type: AMERICAAIRPORTPICKUP, payload: id, data: e.target.value}
}

export function americaDifferentHotel(id, e){
  return {type: AMERICADIFFERENTHOTEL, payload: id, data: e.target.value}
}

export function americaMoreTrips(id, e){
  return {type: AMERICAMORETRIPS, payload:id, data:e.target.value}
}

export function americaRemoveAll(){
  return {type: AMERICAREMOVEALL}
}